import { render, staticRenderFns } from "./SubscriptionCard.vue?vue&type=template&id=afdb20de"
import script from "./SubscriptionCard.vue?vue&type=script&lang=js"
export * from "./SubscriptionCard.vue?vue&type=script&lang=js"
import style0 from "./SubscriptionCard.vue?vue&type=style&index=0&id=afdb20de&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports